export default __webpack_public_path__ + "static/media/bibooSm.201f9116.png";